let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fq9yG")).then(() => parcelRequire('kswjV'));